/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Shot_ApprovalsInputs */

const en_mk_shot_approvals = /** @type {(inputs: Mk_Shot_ApprovalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Approvals page: a queue of agent requests with Approve, Ask for revision and Reject buttons.`)
};

const id_mk_shot_approvals = /** @type {(inputs: Mk_Shot_ApprovalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman Approval: antrean permintaan izin dari agen dengan tombol Setujui, Minta revisi, dan Tolak.`)
};

/**
* | output |
* | --- |
* | "The Approvals page: a queue of agent requests with Approve, Ask for revision and Reject buttons." |
*
* @param {Mk_Shot_ApprovalsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_shot_approvals = /** @type {((inputs?: Mk_Shot_ApprovalsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Shot_ApprovalsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_shot_approvals(inputs)
	return en_mk_shot_approvals(inputs)
});